/*
 * Newbeans — newsletter subscribe + silent welcome-discount apply.
 *
 * Shared by the promotion popup and the footer newsletter form so the 15% welcome
 * offer is delivered identically from either surface:
 *   1. AJAX POST the subscribe to /contact (no full-page reload).
 *   2. On success, silently apply the welcome code to THIS browser session via
 *      /discount/<code> so the discount is already waiting at checkout — independent
 *      of whether the Welcome email is delivered.
 *   3. Hand control back to the caller's onSuccess() to reveal its own success UI
 *      (which also shows the code as a copy/paste fallback for other devices).
 *
 * Falls back to a native form submit on bot-challenge redirects or network errors,
 * so no subscriber is ever lost if fetch is blocked.
 */
(function () {
  if (window.attachNewsletterDiscount) return;

  // Welcome discount code — keep in sync with the Shopify Admin discount + popup CTA.
  var WELCOME_CODE = 'WELCOME15';

  function nativeFallback(form, sourceTag) {
    try {
      sessionStorage.setItem('newsletter_source', sourceTag);
    } catch (e) {}
    var action = form.getAttribute('action') || '/contact';
    form.setAttribute('action', action.split('#')[0]);
    form.submit();
  }

  /*
   * form      — the Shopify {% form 'customer' %} element to intercept.
   * opts.sourceTag — value written to sessionStorage.newsletter_source on native
   *                  fallback so cross-section success handlers can coordinate.
   * opts.onSuccess(form) — invoked after a successful AJAX subscribe to reveal UI.
   */
  window.attachNewsletterDiscount = function (form, opts) {
    if (!form) return;
    opts = opts || {};
    var sourceTag = opts.sourceTag || 'newsletter';

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.newsletter-form__button');
      if (submitBtn && submitBtn.disabled) return;
      if (submitBtn) submitBtn.disabled = true;

      try {
        var formData = new FormData(form);
        // Let fetch follow redirects (Shopify always 302s after a /contact POST).
        var response = await fetch('/contact', { method: 'POST', body: formData });

        // Bot detection: Shopify redirects to /challenge → hand off to native submit.
        if (response.redirected && response.url.indexOf('/challenge') !== -1) {
          nativeFallback(form, sourceTag);
          return;
        }

        // Silently apply the welcome discount to this browser session so the 15%
        // is already waiting at checkout — no button click required.
        fetch('/discount/' + WELCOME_CODE, { credentials: 'same-origin' }).catch(function () {});

        if (typeof opts.onSuccess === 'function') opts.onSuccess(form);
      } catch (err) {
        // Network error → fall back to native submit so the subscribe still lands.
        nativeFallback(form, sourceTag);
      }
    });
  };
})();
